/** USER_SUMMARY.advance 字段 key -> Android Local Feature 名称。 */
export const ANDROID_LOCAL_FEATURE_BY_BADGE_FIELD = {
  location: 'Locations',
  contact: 'Contact',
  sms: 'Text Messages',
  app: 'Installed Apps',
  video: 'Video',
  photo: 'Photo',
  call: 'Calls',
  wifi: 'WI-FI network',
  calendar: 'Calendar',
  screenshot_whatsapp: 'Whatsapp',
  screenshot_line: 'Line',
  screenshot_kik: 'Kik',
  screenshot_facebook_messenger: 'Messenger',
  screenshot_instagram: 'Instagram',
  screenshot_viber: 'Viber',
  screenshot_tinder: 'Tinder',
  screenshot_skype: 'Skype',
  screenshot_youtube: 'Youtube',
  screenshot_snapchat: 'Snapchat',
  screenshot_telegram: 'Telegram',
  screenshot_wechat: 'WeChat',
  screenshot_qq: 'QQ',
  screenshot_facebook: 'Facebook',
  screenshot_teams: 'Teams',
  screenshot_tiktok: 'TikTok',
  screenshot_discord: 'Discord',
  chrome_history: 'Browser History',
  screenshot_botim: 'Botim',
  screenshot_kakaotalk: 'Kakao Talk',
  screenshot_twitter: 'Twitter',
  screenshot_gmail: 'Gmail',
  screenshot_easilydo_mail: 'Easilydo mail',
  key_logger: 'Keylogger',
  live_audio: 'Record Surround',
  live_screenshot: 'Live Screenshot',
  realtime_video_capture: 'Record Video',
  live_video: 'Record Screen',
  keyword_alerts: 'Keyword Alerts',
  monitor_keyword: 'Keyword Alerts',
  app_usage: 'Screen Time',
  notification: 'Notifications',
  realtime_photo_capture: 'Take Photos',
  block_applications: 'Block Applications',
  block_wifi: 'Block Wi-Fi',
  block_website: 'Block Website',
  chatgpt: 'ChatGPT',
  gemini: 'Gemini',
  geofencing: 'Geofence'
}

const BADGE_FIELDS_BY_FEATURE = Object.entries(ANDROID_LOCAL_FEATURE_BY_BADGE_FIELD).reduce(
  (fieldsByFeature, [field, featureName]) => ({
    ...fieldsByFeature,
    [featureName]: [...(fieldsByFeature[featureName] || []), field]
  }),
  {}
)

export const applyAdvanceBadgeCount = (feature, advanceData) => {
  const fields = BADGE_FIELDS_BY_FEATURE[feature.name] || []

  // Keyword Alerts 优先用 keyword_alerts；旧字段 monitor_keyword 仅作回退，避免重复相加。
  const field = fields.find(key => Number(advanceData?.[key]) > 0) || fields[0]
  const count = Number(advanceData?.[field])

  return {
    ...feature,
    num: field && Number.isFinite(count) ? count : 0
  }
}
